import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-module-type2-delete-dialog',
  templateUrl: './module-type2-delete-dialog.component.html',
  styleUrls: ['./module-type2-delete-dialog.component.scss']
})

 
export class ModuleType2DeleteDialogComponent implements OnInit {
  business_entity:any;

  constructor() { }

  ngOnInit(): void {
    this.business_entity=localStorage.getItem('namcvalue')
  }
  deleteRecord(){
    return {
      "business_entity":this.business_entity
    }
  }
}